var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCancelCircleFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#F7F8F9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.2421 20.2426C20.5024 19.9822 20.5024 19.5601 20.2421 19.2997L16.9427 16.0004L20.243 12.7001C20.5033 12.4397 20.5033 12.0176 20.243 11.7573C19.9826 11.4969 19.5605 11.4969 19.3002 11.7573L15.9999 15.0576L12.6996 11.7573C12.4392 11.4969 12.0171 11.4969 11.7568 11.7573C11.4964 12.0176 11.4964 12.4397 11.7568 12.7001L15.0571 16.0004L11.7577 19.2997C11.4973 19.5601 11.4973 19.9822 11.7577 20.2426C12.018 20.5029 12.4402 20.5029 12.7005 20.2426L15.9999 16.9432L19.2993 20.2426C19.5596 20.5029 19.9817 20.5029 20.2421 20.2426Z",
    fill: "#16161E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelCircleFilled);
export default __webpack_public_path__ + "static/media/cancel-circle-filled.962466e30705f6c655b2ca425aab3f53.svg";
export { ForwardRef as ReactComponent };